require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-system-upgrade-scheduled.json") })
        }
      }, "path---articles-system-upgrade-scheduled");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-system-upgrade-scheduled!./.cache/json/articles-system-upgrade-scheduled.json
// module id = 1740
// module chunks = 231608221292675